<style>
.bg-primary {
  background-color: #1a3665 !important;
}
</style>
<template>
<div>
    <!-- Data Workshop -->
    <CCard>
      <CCardHeader
      class="bg-primary text-white border-0 font-weight-bold d-flex align-items-center"> Master RPL
      <template v-if="role_status && role_status.status_export_excel">
        <CButton color="info" class="btn-md ml-auto mr-2" @click="exportDataRpl">Ekspor Excel</CButton>
      </template>
      <template v-else>
        <CButton color="secondary" class="btn-md ml-auto mr-2" disabled>Ekspor Excel</CButton>
      </template>
      <template v-if="role_status && role_status.status_create">
      <router-link to="master-rpl/tambah">
        <CButton color="success" class="btn-md">Tambah</CButton>
      </router-link>
      </template>
      <template v-else>
        <CButton color="secondary" class="btn-md" disabled>Tambah</CButton>
      </template>
    </CCardHeader>
    <CCardBody >
      <div>
      <CRow>
        <div class="col-sm-12 col-xl-12">
          <div class="form-group">
            <label for="" class="font-weight-bold">Pilih Level</label>
            <multiselect
              class="mulit-select"
              label="namaLevel"
              placeholder="Pilih Level"
              :show-labels="false"
              @select="pilihLevel"
              v-model="level"
              required
              id="selectLevel"
              :options="optionMasterLevel"
            ></multiselect>
          </div>
        </div>
      </CRow>
      <CRow>
        <div class="col-sm-12 col-xl-2">
          <div class="form-group">
            <CSelect
              label="Data Perhalaman"
              class="float-left"
              @change="changePageSize"
              v-model.number="pageSize"
              :options="[10, 25, 100, 'Semua Data']"
            />
          </div>
        </div>
        <div class="col-sm-12 col-xl-3 ml-auto">
          <div class="form-group">
            <label for>Pencarian</label>
            <input
              type="text"
              name
              id
              class="form-control"
              placeholder="Cari Data ..."              
              v-model="search"
            />
          </div>
        </div>
      </CRow>
      <CRow ref="mycardloader"> 
        <CCol lg="12" class="table-responsive">
          <CDataTable style="widht:100% !important" :items="items" :fields="fields" hover sorter>
            <template #no="{index}">
              <td class="py-2">{{ indexed == 0 ? index +1: index+indexed + 1 }}</td>
            </template>                        
            <template #kode_rpl="{item}">
              <td class="py-2 font-weight-bold">{{item.kode_rpl ? item.kode_rpl : "-"}}</td>
            </template>
            <template #nama_rpl="{item}">
              <td class="py-2">{{item.nama_rpl ? item.nama_rpl : "-"}}</td>
            </template>
            <template #level="{item}">
              <td class="py-2">{{item.level ? item.level : "-"}}</td>
            </template>
            <template #total_biaya="{item}">
              <td class="py-2" align="left">Rp. {{item.total_biaya ? item.total_biaya : "-"}}</td>
            </template>            
            <template #durasi_rpl="{item}">
              <td class="py-2" align="left">{{item.durasi_rpl ? item.durasi_rpl + " Hari" : "-"}}</td>  
            </template>
            <template #status="{item}">
              <td class="py-2 text-center">
                <i class="fa fa-check text-success" aria-hidden="true" v-if="item.status == 1"></i>
                <font-awesome-icon icon="times" class="text-danger" v-else />
              </td>
            </template>
            <template #aksi="{item, index}">
              <td class="py-2 text-center">
                <template v-if="role_status && role_status.status_update">
                <router-link :to="'/rpl/master-rpl/edit/'+item.id_sertifikasi_rpl">
                  <CButton v-c-tooltip="'Ubah'" color="info" class="btn-sm mx-1" square>
                    <font-awesome-icon icon="edit" />
                  </CButton>
                </router-link>&nbsp;&nbsp;
                </template>
                <template v-else>
                <CButton v-c-tooltip="'Edit'" color="Secondary" class="btn-sm" disabled>
                  <font-awesome-icon icon="edit" />
                </CButton>
                </template>
                <template v-if="role_status && role_status.status_delete">
                <CButton v-c-tooltip="'Hapus'" color="danger" class="btn-sm" square @click="deleteData(item, index)">
                  <font-awesome-icon icon="trash" />
                </CButton>
                </template>
                <template v-else>
                  <CButton v-c-tooltip="'Hapus'" color="secondary" class="btn-sm">
                    <font-awesome-icon icon="trash" />
                  </CButton>
                </template>
              </td>
            </template>
          </CDataTable>
          <CPagination
            style="float:right"
            :active-page.sync="currentPage"
            :pages="pagination.totalPages"
            responsive
            @click="pageChange"
          />
        </CCol>
      </CRow>
      </div>

    </CCardBody>
    </CCard>    
    <!-- End Data provinsi -->
</div>
</template>
<script>
import MasterRplService from "@/services/rpl/master-rpl.service";
import { AlertUtils } from '@/mixins/AlertUtils'
import { Level } from "@/mixins/master/Level";
import { exportUtils } from "@/mixins/exportUtils";

const fields = [
  {
    key: "no",
    sorter: true,
    filter: false
  },
  {
    key: 'kode_rpl',
    label: "Kode",
    sorter: true,
    filter: false
  },
  {
    key: "nama_rpl",
    label: "Nama Sertifikasi RPL",
    sorter: true,
    filter: false
  },
  {
    key: "nama_level",
    label: "Level",
    sorter: true,
    filter: false
  },
  {
    key: "jumlah_mata_uji",
    label: "Jumlah Mata Uji",
    sorter: true,
    filter: false
  },
  {
    key: "total_biaya",
    label: "Biaya",
    sorter: true,
    filter: false
  }, 
  {
    key: "kategori_lokasi",
    label: "Lokasi",
    sorter: true,
    filter: false
  }, 
  {
    key: "status",
    label: "Status Aktif",
    _style: "width: 12% text-align: center",
    sorter: false,
    filter: false
  },
  {
    key: "aksi",
    _style: "width:10%; text-align: center",
    sorter: false,
    filter: false
  }
];

export default {
  name: "master-rpl",
  mixins: [
    AlertUtils, Level, exportUtils
  ],
  data() {
    return {
      items: [],
      pageSize: 10,
      search: "",
      fields,
      pagination: {
        totalPages: 0
      },
      level: '',
      currentPage: 0,
      details: [],
      no: 1,      
      status: false,
      myModal: false,
      horizontal: { label: "col-3", input: "col-9" },
      collapseDuration: 0,
      content: [],
      indexed: 0,
      loading: true,
      timeout : 0,
      role_status: null
    };
  },
  mounted() {
    this.getAllLevel();    
    this.tipe_halaman = "all_data";
    this.roleData();

    setTimeout(() => {      
      this.getData("0", this.pageSize, "default", this.level.idLevelAnggota);
    }, 1000)
  },
  
  watch: {
    search : function (val) {
      clearTimeout(this.timeout);
      var vm = this
      this.timeout = setTimeout(function () {        
        vm.getData("0", vm.pageSize, vm.search, vm.level.idLevelAnggota);
      }, 1000);
    },
    currentPage: function(val){      
      var page = val - 1;
      this.indexed = page * this.pageSize;
      this.getData(val - 1, this.pageSize, this.search, this.level.idLevelAnggota);      
    }
  },
  methods: {
    roleData()
    {
      var user = JSON.parse(localStorage.getItem('user'));
      var data = user.singleData.detail_user.roles.find(el => el.url === this.$route.path );  
      this.role_status = data;
    },
    changePageSize(e) {      
      var pageSize = "";
      if (e.target.value == "Semua Data") {
        pageSize = "500";
        this.pageSize = pageSize;
      } else {
        pageSize = e.target.value;
        this.pageSize = pageSize;
      }
      this.getData("0", pageSize, this.search, this.level.idLevelAnggota);
    },

    pilihLevel(value){
      if(value.idLevelAnggota == 'default') {
        this.getData("0", this.pageSize, 'default', 'default');
      }      
      this.level = value;
      this.getData("0", this.pageSize, 'default', value.idLevelAnggota);
    },

    pageChange() {
      this.getData(this.currentPage, this.pageSize, this.search, this.level.idLevelAnggota);
    },    

    deleteData(item) {      
      var vm = this;      
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            let loader = this.$loading.show({
              container: false ? null : this.$refs.mycardloader,
              canCancel: true,
              onCancel: this.onCancel
            });
            
            MasterRplService.deleteDataSertifikasiRpl(item.id_sertifikasi_rpl)
              .then(response => {
                loader.hide();
                this.alertDeleteSuccess();
                this.getData("0", this.pageSize, this.search, this.level.idLevelAnggota);
              })
              .catch(error => {
                loader.hide();
                this.alertError(error.response.data.message);
                this.getData("0", this.pageSize, this.search, this.level.idLevelAnggota);                
              });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    getData(currentPage, pageSize, filter, idLevel) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.mycardloader,
        canCancel: true,
        onCancel: this.onCancel
      });
      var vm = this;
      MasterRplService.getDataSertifikasiRpl(currentPage, pageSize, filter, idLevel)
        .then(response => {
          vm.items = response.data.data.content;
          vm.pagination.totalPages = response.data.data.totalPages;
          vm.currentPage = response.data.data.pageable.pageNumber + 1;

          loader.hide();       
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },
    
    exportDataRpl(idLevelAnggota) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.dataDokumen,
        canCancel: true,
        onCancel: this.onCancel
      });
      MasterRplService.exportDataRpl(this.level.idLevelAnggota)
      .then(response => {
          alert(this.level.idLevelAnggota)
          loader.hide()
          this.exportData(response.data, 'master-rpl');
          this.alertExportSuccess();
          this.getData("0", this.pageSize, this.search, this.level.idLevelAnggota);
        })
      .catch(error => {
          loader.hide()
          this.alertExportFailed();
          this.getData("0", this.pageSize, this.search, this.level.idLevelAnggota);
      })
    },
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>